<template>
  <div class="comment-form">
    <div class="pop" v-show="!show" @click="handleClose"></div>
    <div class="user_input" v-show="!show">
      <div class="dialog-con">
        <div class="con-top">
          <img :src="userInfo && userInfo.headPicUrl" class="top-cover" alt="" />
          <div class="top-txt">{{ userInfo && userInfo.nickName }}</div>
          <div class="top-close" @click="handleClose">取消</div>
        </div>
        <div class="input">
          <van-field v-model="message" rows="3" autosize type="textarea" maxlength="50" placeholder="请输入你的评论" />
        </div>
        <div class="btn">
          <div class="submit" @click="handleSubmit">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commentApi } from '@/api/zone'
export default {
  name: 'commentForm',
  data() {
    return {
      message: '',
      show: true,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  props: {
    detailData: {},
    commentableId: '',
    targetContent: ''
  },
  watch: {
    detailData(newval) {
      this.details = newval
    }
  },
  methods: {
    handleClose () {
      this.show = true
    },
    handleSubmit () {
      if (this.isLoad) {
        return
      }
      this.isLoad = true
      let params = {
        targetUserId: this.details.iepUserDTO.id,
        targetHeadPic: this.details.iepUserDTO.headPicUrl,
        targetUserName: this.details.iepUserDTO.realName,
        commentableId: this.commentableId ? this.commentableId : this.details.id,
        targetContent: this.targetContent ? this.targetContent : this.details.subjectName,
        userId: this.userInfo.id,
        userHeadPic: this.userInfo.headPicUrl,
        userName: this.userInfo.realName,
        content: this.message,
        anonymity: 0,
        // 类型类型1rtc专区2病例交流3评论
        type: this.commentableId ? '3' : '1',
        postbarId: this.$route.query.postId
      }
      commentApi(params).then(res => {
        this.isLoad = false
        if (`${res.code}` === '0') {
          this.$toast('评论成功')
          this.show = true
          this.message = ''
          params.id = res.data
          this.$emit('handleSucc', params)
        }
      }).catch(err => {
        this.isLoad = false
        this.$toast(err.msg)
      })
    },
  }
}
</script>
<style lang="less" scoped>
.comment-form {

  .user_input {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 375px;
    height: 208px;
    background: #ffffff;
    box-shadow: 0 -5px 10px -5px #eee;
    z-index: 9;

    .dialog-con {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 205px;

      .con-top {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 50px;

        .top-cover {
          width: 32px;
          height: 32px;
          margin-right: 5px;
          border-radius: 50%;
          display: block;
        }

        .top-txt {
          flex: 1;
          font-size: 14px;
          color: #000000;
        }

        .top-close {
          font-size: 14px;
          color: #000000;
        }
      }

      .input {
        padding: 0 20px;
        box-sizing: border-box;

        .van-cell {
          background: #f5f5f5;
          border-radius: 8px;
        }
      }

      .btn {
        margin-top: 10px;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        text-align: right;

        .submit {
          display: inline-block;
          width: 56px;
          height: 27px;
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
          border-radius: 30px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          line-height: 27px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/commentForm.vue